import { EditableCriteria } from 'modules/queryBuilder/types';
import { applyRequirementTransformations } from './applyRequirementTransformations';

/**
 * Applies schema transformations to a single criteria
 */
export const applyCriteriaTransformations = (criteria: EditableCriteria): EditableCriteria => {
  return {
    ...criteria,
    searchQueries: (criteria?.searchQueries || []).map((requirement) =>
      applyRequirementTransformations(requirement),
    ),
  };
};
